// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

// import Autocomplete from '@mui/material/Autocomplete';
import BackdropProgress from '../../../BackdropProgress';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import Button from '@mui/material/Button';
// import ConfirmationDialog from '../../dialog/ConfirmationDialog';
import CircularProgress from '@mui/material/CircularProgress';
import CustomSnackbar from '../../ui/Snackbars';
// import SaveIcon from '@mui/icons-material/Save';
import Grid from '@mui/material/Grid'
import LinearProgress from '@mui/material/LinearProgress';
import no_image_availiable from '../../../images/no_image_available.jpeg';
import Paper from '@mui/material/Paper';
import React from 'react';
// import TextField from '@mui/material/TextField';
import useHttp from '../../../utils/http';
import { adjustForTimezone, getCountryNameFromCountryCode, getDateForDB, imageContentToImage } from '../../../utils/formatting';
import { getEmployeeOwnVisaImage, getOwnVisaImage, getUserPassportList, postSearchOwnTravelDocuments, putTravelOperation, putVisaPassport } from '../../../utils/end-points.js';
import { getVisaStatusColor } from '../../../theme/status-colors';
// import { isAccessGranted } from "../../../utils/oauth";
import { travelDocumentTypes, visaStatus } from '../../../utils/const';
// import { PRIVILEGES } from "../../../Config.js";
import { useState, useEffect, useCallback } from 'react';
import "../../../css/UserVisaInfoCard.scss"

const UserVisaInfoCard = (props) => {

    const [selectedVisa, setSelectedVisa] = useState()
    const [snackbarData, setSnackbarData] = useState({ open: false, message: "", severity: "", onClose: null })
    const [imageSrc, setImageSrc] = useState("")
    // const [isVisaActive, setVisaActive] = useState(false)
    const [imageName, setImageName] = useState("")
    // const [passportInputValue, setPassportInputValue] = useState('')
    // const [passportList, setPassportList] = useState([])
    const [passport, setPassport] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [isImageLoading, setIsImageLoading] = useState(false)
    const [isPassportsLoading, setPassportsLoading] = useState(false)
    const { handleRequest, handleFileRequest } = useHttp()

    useEffect(() => {
        setSelectedVisa(props.selectedVisa)
        setIsLoading(false)
        // setIsVisaInfoChanged(false)
        fetchVisaImage(props.selectedVisa.id)
        fetchUserPassportList(props.selectedVisa.passportId)

        // var visaEndDate = adjustForTimezone(new Date(props.selectedVisa.end_date))
        // var currentDate = new Date()
        // if(getDateForDB(currentDate) <= getDateForDB(visaEndDate)){
        //     setVisaActive(true)
        // }
        // else{
        //     setVisaActive(false)
        // }
    }, [props.selectedVisa])

    const fetchUserPassportList = useCallback(async (id) => {

        if(id) {
            setPassportsLoading(true)
            let body = {
                status: "active",
                id: id
            }
    
            handleRequest(postSearchOwnTravelDocuments, "POST", body, (travelDocuments) => {
                if (travelDocuments) {
                    if (travelDocuments.length > 0) {
                        setPassport(travelDocuments[0])
                    }
                    else {
                        setPassport(null)
                    }
                }
                else {
                    setSnackbarData({ message: "Error while fetching Travel Documents", open: true, severity: "error", onClose: onCloseSnackbar })
                }
                setPassportsLoading(false)
            }, (error) => {
                setPassportsLoading(false)
                setSnackbarData({ message: "Error while fetching Travel Documents", open: true, severity: "error", onClose: onCloseSnackbar })
                console.error(error)
            })
        }
        else {
            setPassport(null)
        }

    }, [])

    const fetchVisaImage = useCallback(async (visaId) => {
        setIsImageLoading(true)

        let url = getEmployeeOwnVisaImage.replace("$id", visaId)
        handleFileRequest(url, "GET", null, (data) => {
            if (data.blobContent) {
                setImageSrc(imageContentToImage(data.blobContent))
                setImageName("Travel Document Image")
                setIsImageLoading(false)
            }
            else {
                setImageName("No image available")
                setImageSrc(no_image_availiable)
                setIsImageLoading(false)
            }
        }, (error) => {
            setSnackbarData({ message: error, open: true, severity: "error", onClose: onCloseSnackbar })
        })
    }, [props.selectedVisa])

    const getVisaStatus = () => {
        var visaEndDate = adjustForTimezone(new Date(selectedVisa.endDate))
        var currentDate = new Date()

        return <span className='Status-chip'
            style={{
                backgroundColor: getVisaStatusColor(getDateForDB(currentDate) <= getDateForDB(visaEndDate)),
                color: "white"
            }}>
            {(getDateForDB(currentDate) <= getDateForDB(visaEndDate)) ? visaStatus.ACTIVE : visaStatus.EXPIRED}
        </span>
    }

    const onCloseSnackbar = () => {
        setSnackbarData({ ...snackbarData, open: false })
    }

    // const setPassportValue = (value) => {
    //     setPassport(value)
    //     setIsVisaInfoChanged(true)
    // }

    // const editVisaPassportConfirmation = () => {
    //     setConfirmationDialogData({
    //         open: true,
    //         title: "Edit Visa Passport",
    //         content: "Are you sure you want to edit the passport for this Visa?",
    //         acceptLabel: "Yes",
    //         declineLabel: "No",
    //         acceptAlert: editVisaPassport,
    //         declineAlert: handleDeclineAlert
    //     })
    // }


    // const editVisaPassport = useCallback(async () => {

    //     setConfirmationDialogData(data => ({ ...data, open: false }))
    //     const url = putVisaPassport+ '?visaId=' + selectedVisa.id + '&passportId=' + passport.id
    //     handleRequest(url, "PUT", null, (data) => {
    //         if (data > 0) {
    //             props.refreshVisaList()
    //         }
    //         else {
    //             setSnackbarData({ message: "Failed", open: true, severity: "error", onClose: onCloseSnackbar })

    //         }
    //     }, (error) => {
    //         setSnackbarData({ message: error, open: true, severity: "error", onClose: onCloseSnackbar })
    //     })
    // })

    // const handleDeclineAlert = () => {
    //     setConfirmationDialogData(data => ({ ...data, open: false }))
    // }

    return (
        <React.Fragment>

            <CustomSnackbar snackbar={snackbarData} />

            {/* <ConfirmationDialog confirmationDialogData={confirmationDialogData} /> */}

            <BackdropProgress open={isLoading} />

            <div className='User-visa-info-cards'>
                {!isLoading && (
                    <Paper className='Details-paper Border-elevation'>
                        <div className='Visa-info-title'>
                            <span>Visa Information</span>
                            {/* <span className='Edit-visa-span'>{isAccessGranted([PRIVILEGES.EDIT_OWN_VISA_TAGGED_PASSPORT]) && selectedVisa && <Button variant="contained" startIcon={<SaveIcon />} color="secondary" className='Save-visa-button'
                                onClick={() => editVisaPassportConfirmation()} disabled={!isVisaInfoChanged || !passport}>Save</Button>}</span> */}
                        </div>
                        <Grid container className='Visa-info-entry'>
                            <Grid item lg={4} className='Visa-info-span'>Country : </Grid>
                            <Grid item lg={8}>{getCountryNameFromCountryCode(selectedVisa.country) ? getCountryNameFromCountryCode(selectedVisa.country) : selectedVisa.country}</Grid>
                        </Grid>
                        <Grid container className='Visa-info-entry'>
                            <Grid item lg={4} className='Visa-info-span'>Visa Type : </Grid>
                            <Grid item lg={8}>{selectedVisa.visaType}</Grid>
                        </Grid>
                        <Grid container className='Visa-info-entry'>
                            <Grid item lg={4} className='Visa-info-span'>Entry Type : </Grid>
                            <Grid item lg={8}>{selectedVisa.entryType}</Grid>
                        </Grid>
                        <Grid container className='Visa-info-entry'>
                            <Grid item lg={4} className='Visa-info-span'>Start Date : </Grid>
                            <Grid item lg={8}>{getDateForDB(adjustForTimezone(new Date(selectedVisa.startDate)))}</Grid>
                        </Grid>
                        <Grid container className='Visa-info-entry'>
                            <Grid item lg={4} className='Visa-info-span'>End Date : </Grid>
                            <Grid item lg={8}>{getDateForDB(adjustForTimezone(new Date(selectedVisa.endDate)))}</Grid>
                        </Grid>
                        <Grid container className='Visa-info-entry'>
                            <Grid item lg={4} className='Visa-info-span'>Issued Date : </Grid>
                            <Grid item lg={8}>{getDateForDB(adjustForTimezone(new Date(selectedVisa.issuedDate)))}</Grid>
                        </Grid>
                        <Grid container className='Visa-info-entry'>
                            <Grid item lg={4} className='Visa-info-span Grid-item-center'>Passport : </Grid>
                            <Grid item lg={8} className='Grid-item-center'>
                                {isPassportsLoading
                                    ? <Box sx={{ width: '100%' }}>
                                        <LinearProgress color="secondary" />
                                    </Box> : (passport
                                        ? getCountryNameFromCountryCode(passport.issuedCountry) + "  [" + passport.documentNo + "]" 
                                        : "No Passport Tagged")}
                                {/* {getCountryNameFromCountryCode(passport.issuedCountry) + " - " + passport.documentNo + " ( " + getDateForDB(adjustForTimezone(new Date(passport.issuedDate))) + " - " + getDateForDB(adjustForTimezone(new Date(passport.expiryDate))) + " )"} */}
                                {/* <Autocomplete
                                    size="small"
                                    loading = {isPassportsLoading}
                                    noOptionsText = 'No options'
                                    disabled={!isVisaActive}
                                    disablePortal
                                    fullWidth
                                    value={passport}
                                    onChange={(_, newValue) => {
                                      setPassportValue(newValue)
                                    }}
                                    inputValue={passportInputValue}
                                    onInputChange={(_, newInputValue) => {
                                      setPassportInputValue(newInputValue)
                                    }}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    options={passportList.filter(passport=>passport.status==travelDocumentStatus.ACTIVE)}
                                    getOptionDisabled={(option)=>option.isExpired===true}
                                    getOptionLabel={(option) => getCountryNameFromCountryCode(option.issuedCountry) + " - " + option.documentNo + " ( " + getDateForDB(adjustForTimezone(new Date(option.issuedDate))) + " - " + getDateForDB(adjustForTimezone(new Date(option.expiryDate))) + " )"}
                                    renderOption={(props, option) => (
                                        <Box className='Passport-dropdown-textfield' style={{ fontSize: 15, color: option.isExpired ? "red" : null }} {...props}>{getCountryNameFromCountryCode(option.issuedCountry) + " - " + option.documentNo + " ( " + getDateForDB(adjustForTimezone(new Date(option.issuedDate))) + " - " + getDateForDB(adjustForTimezone(new Date(option.expiryDate))) + " )"}</Box>
                                    )}
                                    renderInput={(params) => <TextField {...params} label="Passport" />}
                                /> */}
                            </Grid>
                        </Grid>
                        {
                            !isPassportsLoading && passport && (
                                <Grid container className='Visa-info-entry'>
                                    <Grid item lg={4} className='Visa-info-span Grid-item-center'>Passport Validity Period: </Grid>
                                    <Grid item lg={8} className='Grid-item-center'>
                                        {getDateForDB(adjustForTimezone(new Date(passport.issuedDate))) + " - " + getDateForDB(adjustForTimezone(new Date(passport.expiryDate)))}
                                    </Grid>
                                </Grid>
                            )
                        }
                        {props.selectedVisa && (
                            <Grid container className='Visa-info-entry'>
                                <Grid item lg={4} className='Visa-info-span'>Visa Status : </Grid>
                                <Grid item lg={8}>{getVisaStatus()}</Grid>
                            </Grid>
                        )}
                        <div className={props.id ? 'Visa-image-div-for-popup' : 'Visa-image-div-for-card'}>
                            {isImageLoading ? <CircularProgress className='Secondary-loader' color="secondary" /> : <img id="image" src={imageSrc} alt={imageName} className='Visa-image' />}
                        </div>
                    </Paper>
                )}
            </div>

        </React.Fragment>
    );
}

export default UserVisaInfoCard;